<template>
  <div class="page" ref="scrollPage">
    <Header @setScroll="setScroll" :theme="white"></Header>
    <!---轮播图 start-->
    <div class="wrapper" id="home">
      <!-- <div class="bannerWrap bannerWrap3">
        <div class="bannerBtn" id="bannerBtn">联系我们</div>
        <div class="flagWrap elliptical" ref="elliptical">
          <div v-for="(item, index) in runPoint" :key="index" class="flagBox" :id="'flagBox'+index" :style="{top: item.value[0] + 'px', left: item.value[1] + 'px',animation:'doMove'+index+' 5s infinite linear'}" style="transform: scale(1,1);">
            {{index}}
          </div>
        </div>
      </div> -->
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide>
          <div class="bannerWrap bannerWrap1">
            <!-- <div class="leftContnet">
              <div class="bigTit">山西省工业互联网</div>
              <div class="subTit">公共服务平台</div>
              <div class="info">公共服务平台旨在为山西工业企业提供服务。信息包括二级节点平台监测，应用市场，解决方案，政策支持，平台案例，新闻咨询等。</div>
            </div> -->
            <!-- <div class="bannerBtn">联系我们</div> -->
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="bannerWrap bannerWrap2">
            <!-- <div class="leftContnet">
              <div class="bigTit">二级节点</div>
              <div class="info">二级节点向上可对接国家顶级节点，向下可对接各企业节点，核心业务为标识注册和标识解析服务，以及标识解析相关的业务管理、数据管理等内容。</div>
            </div> -->
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="bannerWrap bannerWrap3">
            <!-- <div class="leftContnet">
            <div class="bigTit">整合应用 各取所需</div>
            <div class="info">依据各行业，各领域的实际应用场景，整合多款APP应用。企业可根据需求，选取相应的应用。</div>
            </div> -->
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="bannerWrap bannerWrap4">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="bannerWrap bannerWrap5">
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!---轮播图 end-->
    <!--政策资讯-->
    <div class="zcInformation" id="zcInformation" ref="zcInformation">
      <div class="zcInner">
        <div class="zcTit">政策资讯</div>
        <div class="zcWrap">

          <div class="zcInfoBox">
            <div class="topInfo topInfo1">政策支持 <span @click="toSecondLevel('PolicyList')">查看更多<img
                  src="../assets/images/jt_arrow2@2x.png" /></span></div>
            <div @click="goPolDetail(policyList[0].id)" class="topImgBox"
              :style="[{ 'background': `url(${baseURL + policyList[0].image}) center top no-repeat` }, { 'background-size': '100% 100%' }]">
              <div class="topImgBar"><span class="lineText">{{ policyList[0].title }}</span> <span class="time">{{
                policyList[0].publishTime.substr(0, 10) }}</span></div>
            </div>
            <div class="zcInfoList">
              <div class="infoItem" v-for="(item, index) in policyList" :key="item.title" @click="goPolDetail(item.id)">
                <span class="lineText">{{ item.title }}</span>
                <span class="time">{{ item.publishTime.substr(0, 10) }}</span>
              </div>
            </div>
          </div>

          <div class="zcInfoBox">
            <div class="topInfo topInfo2">工业资讯 <span @click="toSecondLevel('IndustryList')">查看更多<img
                  src="../assets/images/jt_arrow2@2x.png" /></span></div>
            <div @click="goPolDetail(dynamicData[0].id)" class="topImgBox"
              :style="[{ 'background': `url(${baseURL + dynamicData[0].image}) center top no-repeat` }, { 'background-size': '100% 100%' }]">
              <div class="topImgBar" @click="goPolDetail(dynamicData[0].id)"><span class="lineText">{{
                dynamicData[0].title }}</span> <span class="time">{{ dynamicData[0].publishTime.substr(0, 10) }}</span>
              </div>
            </div>
            <div class="zcInfoList">

              <div class="infoItem" v-for="(item, index) in dynamicData" :key="item.title"
                @click="goNewsDetails(item.id)">
                <span class="lineText">{{ item.title }}</span>
                <span class="time">{{ item.publishTime.substr(0, 10) }}</span>
              </div>

            </div>
          </div>



        </div>
      </div>


    </div>

    <!-- 解决方案 -->
    <div class="final" id="solution" ref="solution">
      <div class="wrapTit wrapTit2 pb80">
        解决方案
      </div>
      <div style="width: 1373px;margin: 0 auto;display: flex;justify-content: flex-start;align-items: center;">
        <div style="display: flex;flex-direction: column;width: 399px;margin-right: 20px;" v-if="jjfaList">
          <div v-for="(item, index) in jjfaList" :key="item.id" class="jjfaLeftItem" @click="tap(index + 1)"
            :class="{ 'active': active == (index + 1) }">
            <div>
              <div>
                <span class="activeArrow"></span>
                <span class="jjfaLeftItemTit">{{ item.topTitle }}</span>
              </div>
              <div class="jjfaLeftItemSubTit">
                {{ item.topSubTitle }}</div>
            </div>
          </div>
          <div class="jjfaMoreBtn" @click="toSolutionList">查看更多解决方案 > </div>
        </div>
        <div v-for="(item, index) in jjfaList" :key="item.id" class="jjfaRightBlock" v-if="active == (index + 1)"
          :style="{ 'background': `url(${baseURL + item.subImage})` }">
          <div>
            <div class="jjfaRightTit">{{ item.topTitle }}</div>
            <div class="content">
              {{ item.solutionText }}
            </div>
            <div class="moreBtn" @click="toDetails(item.id)">
              了解更多</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 应用市场 -->
    <div id="market" class="yyscWrap" ref="market">
      <div class="wrapTit"> 应用市场</div>
      <div class="yyscWrapBody">
        <div class="yyscLeft">
          <div class="yyscSubTit">多应用平台</div>
          <div class="yyscContent">
            <img class="cirIcon" src="../assets/images/circular@2x.png" />
            <span style="width: 80%">按照各个行业的实际应用场景，整合多类型应用到公共服务平台，企业可按需选取所需的应用同时支持用户登录一次便可访问多个应用。</span>
          </div>
          <div class="moreApp" @click="goMoreApp">查看更多应用 ></div>
          <!---应用轮播开始-->
          <div>
            <swiper class="yyOutWrap" :options="swiperOption2" ref="mySwiper" v-if="yyData.length">
              <swiper-slide v-for="(item, index) in yyData" :key="index">
                <div class="mySlide">
                  <div class="yyItemBox" v-for="(groupItem, idx) in item" :key="idx">
                    <img class="iconImg" :src="baseURL + groupItem.logo" :id="groupItem.id" />
                    <div :id="groupItem.id">
                      <div class="itemName" :id="groupItem.id">{{ groupItem.title }}</div>
                      <div class="itemCont" :id="groupItem.id">{{ groupItem.desStr }}<span :id="groupItem.id">{{
                        getNum(groupItem.num) }}</span></div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>

          <!--应用轮播开始-->
        </div>
        <img class="yyscImg" src="../assets/images/yysc@2x.png" @click="openDialog" />
      </div>
    </div>

    <!--IOT平台-->
    <div id="iot" class="iotWrap">
      <div class="iotTit">IOT平台</div>
      <div class="iotInnerWrap">
        <div class="iotLeft">
          <div>
            <img class="cirIcon" src="../assets/images/circular@2x.png" />
            <span>物联网平台，通过射频识别、感应器、定位系统、扫描器等信息传感设备，按照约定的协议，把各种物品与互联网连接起来，并进行数据交换，实现对物品的智能化管理。</span>
          </div>
          <div>
            <img class="cirIcon" src="../assets/images/circular@2x.png" />
            <span>
              当前在以下行业提供技术支持:
              <em style="padding-top: 8px;"><b>➤</b>化学纤维制造行业 </em>
              <em><b>➤</b>木材加工和木、竹、藤、棕、草制品行业 </em>
              <em><b>➤</b>矿山机械制造行业、煤炭加工行业与电力生产行业 </em>
              <em><b>➤</b>煤化工、冶金、高端装备制造行业 </em>
              <em><b>➤</b>教育装备行业 </em>
              <em><b>➤</b>煤炭开采洗选业和农副食品加工行业 </em>
            </span>
          </div>
        </div>
        <div class="iotRight">
          <span class="name name0">传感器</span>
          <span class="line line0"></span>

          <span class="name name1">智能手机</span>
          <span class="line line1"></span>

          <span class="name name2">汽车</span>
          <span class="line line2"></span>

          <span class="name name3">机器人</span>
          <span class="line line3"></span>

          <span class="name name4">可穿戴设备</span>
          <span class="line line4"></span>

          <span class="name name5">智能家电</span>
          <span class="line line5"></span>

        </div>
      </div>
    </div>

    <!-- 供需平台 -->
    <div class="platform" id="platform" ref="platform">
      <div class="wrapTit wrapTit2 pb140 platTit">
        供需平台
      </div>
      <div class="platformBody">
        <img class="leftImg" src="../assets/images/gx_sc@2x.png">
        <div>

          <div class="platformItem">
            <div style="margin-right: 10px;">
              <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
            </div>
            <div class="itemCont">提供需求平台、供应平台。</div>
          </div>

          <div class="platformItem">
            <div style="margin-right: 10px;">
              <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
            </div>
            <div class="itemCont"> 连通各个群体，各个行业，各个地域。</div>
          </div>

          <div class="platformItem">
            <div style="margin-right: 10px;">
              <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
            </div>
            <div class="itemCont">打破信息孤岛，促进流通效率。</div>
          </div>

          <div class="btnsBox">
            <div class="blueBtn mr23" @click="release">我要发布</div>
            <div class="whiteBtn" @click="goDiscuss">我要逛逛</div>
          </div>

        </div>
      </div>
    </div>


    <!-- 二级节点 标识解析 -->
    <div id="node" class="two handleWrap" ref="node">
      <div style="margin: 0 auto;">
        <div style="font-size: 40px;font-family: PingFang SC;font-weight: 500;color: #121E30;text-align: center;">标识解析
        </div>
        <div
          style="width: 1300px;display: flex;justify-content: space-around;margin: 90px auto 0;padding: 0 40px;box-sizing: border-box;">
          <div style="display: flex;justify-content: center;align-items: center;width: 215px;cursor: pointer;"
            @click="tabNode(1)">
            <img v-if="activeIndex == 1" src="../assets/images/jxIcon1.png"
              style="width: 30px;height: 27px;margin-right: 5px;">
            <img v-else src="../assets/images/jxIcon1_grey.png" style="width: 30px;height: 27px;margin-right: 5px;">
            <div class="nodeTit" :class="{ 'active': activeIndex == 1 }">二级节点</div>
          </div>
          <div style="display: flex;justify-content: center;align-items: center;width: 215px;cursor: pointer;"
            @click="tabNode(2)">
            <img v-if="activeIndex == 2" src="../assets/images/jxIcon2.png"
              style="width: 24px;height: 27px;margin-right: 5px;">
            <img v-else src="../assets/images/jxIcon2_grey.png" style="width: 24px;height: 27px;margin-right: 5px;">
            <div class="nodeTit" :class="{ 'active': activeIndex == 2 }">企业节点</div>
          </div>
          <!-- <div style="display: flex;justify-content: center;align-items: center;width: 215px;cursor: pointer;"
            @click="tabNode(3)">
            <img v-if="activeIndex == 3" src="../assets/images/icon_rc@2x.png"
              style="width: 25px;height: 26px;margin-right: 5px;">
            <img v-else src="../assets/images/icon_rc2@2x.png" style="width: 25px;height: 26px;margin-right: 5px;">
            <div class="nodeTit" :class="{'active': activeIndex == 3}">人才培训</div>
          </div> -->
        </div>
      </div>
      <div
        style="1373px;height: 2px;background: linear-gradient(90deg, #F3F8FF, #D1E2FD, #FFFFFF);border-radius: 1px;margin: 30px auto 0;display: flex;justify-content: space-between;padding: 0 40px;box-sizing: border-box;">
        <!-- <div v-if="activeIndex == 1" style="width: 215px;height: 2px;background: #0C67D8;transform: translateX(0px);">
        </div>
        <div v-if="activeIndex == 2" style="width: 215px;height: 2px;background: #0C67D8;transform: translateX(456px);">
        </div>
        <div v-if="activeIndex == 3" style="width: 215px;height: 2px;background: #0C67D8;transform: translateX(912px);">
        </div> -->
      </div>
      <div
        style="width: 1300px;margin: 30px auto 0;height: 390px;display: flex;justify-content: space-between; align-items: center;;">
        <div style="width: 680px;">
          <div
            style="font-size: 24px;font-family: PingFang SC;font-weight: 500;color: #121E30;line-height: 36px;margin: 120px 0 30px;">
            <div v-if="activeIndex == 1">二级节点</div>
            <div v-if="activeIndex == 2">企业节点</div>
            <!-- <div v-if="activeIndex == 3">人才培训</div> -->
          </div>
          <div v-if="activeIndex == 1">
            <div style="display: flex;justify-content: flex-start;padding: 5px 0 10px 0;"
              v-for="(item, index) in AnalysisData[0].array" :key="index">
              <div style="line-height: 32px;margin-right: 10px;">
                <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
              </div>

              <div style="font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #516381;line-height: 32px;">
                {{ item }}
              </div>
            </div>
            <!-- <div style="display: flex;justify-content: flex-start;padding: 5px 0 10px 0;">
              <div style="line-height: 32px;margin-right: 10px;">
                <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
              </div>
              <div style="font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #516381;line-height: 32px;">
                作为推动标识产业应用规模性发展的主要抓手，二级节点是打造有价值的行业级标识应用、探索可持续发展业务模式的关键。</div>
            </div> -->

          </div>

          <div v-if="activeIndex == 2">
            <div style="display: flex;justify-content: flex-start;padding: 5px 0 10px 0;"
              v-for="(item, index) in AnalysisData[1].array" :key="index">
              <div style="line-height: 32px;margin-right: 10px;">
                <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
              </div>

              <div style="font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #516381;line-height: 32px;">
                {{ item }}</div>
            </div>

          </div>

          <div
            style="width: 368px;height: 1px;background: linear-gradient(90deg, #C8D2E2, #FFFFFF);border-radius: 1px;margin-top: 40px;">
          </div>
          <div v-if="activeIndex === 1"
            style="width: 134px;height: 46px;background: #0C67D8;box-shadow: 0px 3px 10px 0px rgba(127,166,214,0.73);border-radius: 23px;color: #fff;text-align: center;line-height: 46px;margin-top: 60px;cursor: pointer;"
            @click="goSecondaryNode">
            了解更多</div>
          <div v-if="activeIndex === 2"
            style="width: 134px;height: 46px;background: #0C67D8;box-shadow: 0px 3px 10px 0px rgba(127,166,214,0.73);border-radius: 23px;color: #fff;text-align: center;line-height: 46px;margin-top: 60px;cursor: pointer;"
            @click="goCompanyNode">
            了解更多</div>

        </div>
        <img v-if="activeIndex == 1" :src="baseURL + AnalysisData[0].image" style="width: 573px; margin-top: 50px;">
        <!--AnalysisData[0].image--->
        <img v-if="activeIndex == 2" :src="baseURL + AnalysisData[1].image" style="width: 573px; margin-top: 50px;">
        <!-- <img v-if="activeIndex == 3" src="../assets/images/rc@2x.png" style="width: 573px; margin-top: 50px;"> -->
      </div>
    </div>

    <!--数据服务-->
    <div class="dataService" id="data" ref="data">
      <div class="wrapTit wrapTit2 pb107">
        数据服务
      </div>
      <div class="dataBody">
        <div class="datasWrap">
          <div class="dataImgWrap">
            <img src="../assets/images/ptsj@2x.png" class="dataImg" />
            <div class="mask"></div>
          </div>
          <div class="dataMsg">
            <div class="topTit">跨平台数据服务</div>
            <div class="con">通过采集和汇聚企业分散在多个工业互联网平台上的数据，并进行数据整合分析，为企业生产运营优化和决策分析提供跨平台数据服务。</div>
          </div>
        </div>

        <div class="datasWrap">
          <div class="dataImgWrap">
            <img src="../assets/images/jcsj@2x.png" class="dataImg" />
            <div class="mask"></div>
          </div>
          <div class="dataMsg">
            <div class="topTit">基础数据服务</div>
            <div class="con">企业可通过订购单一工业互联网平台提供的数据服务来满足自身数字化转型需求，如企业设备维护数据服务、企业能耗数据服务等。</div>
          </div>
        </div>
      </div>
    </div>

    <!--人才服务-->
    <div class="talentService" id="talent" ref="talent">
      <div class="wrapTit pb120">
        人才服务
      </div>
      <div class="talentBody">

        <div class="talentCard">
          <div class="aniBox">
            <img src="../assets/images/j_1@2x.png" class="aniImg1" />
            <img src="../assets/images/j_2@2x.png" class="aniImg2" />
          </div>
          <img src="../assets/images/di@2x.png" class="diImg" />
          <div class="cardTit">教学平台</div>
          <div class="cardCon">灵活的实验教学管理功能；丰富的课程资源；学练测评一体化流程。</div>
        </div>

        <div class="talentCard">
          <div class="aniBox">
            <img src="../assets/images/k_1@2x (1).png" class="aniImg1" />
            <img src="../assets/images/k_2@2x (1).png" class="aniImg2" />
          </div>
          <img src="../assets/images/di@2x.png" class="diImg" />
          <div class="cardTit">科研平台</div>
          <div class="cardCon">实验资源能够按需分配和弹性扩展；丰富的镜像资源和工具软件。</div>
        </div>

        <div class="talentCard">
          <div class="aniBox">
            <img src="../assets/images/s_1@2x.png" class="aniImg1" />
            <img src="../assets/images/s_2@2x.png" class="aniImg2" />
          </div>
          <img src="../assets/images/di@2x.png" class="diImg" />
          <div class="cardTit">人才储备</div>
          <div class="cardCon">将人才从层次、数量、结构上进行设计优化，实现长期性、持久性、针对性的人才库存和培养。</div>
        </div>

      </div>
    </div>
    <!--信息安全-->
    <div class="safe" id="safe" ref="safe">
      <div class="safeTit">信息安全</div>
      <div class="safeWrap">
        <div class="safeLeft">
          <img class="safeDun dunAni" src="../assets/images/safeDun.png" />
          <img class="safeYing yingAni" src="../assets/images/safeYing.png" />
          <img class="safeDi" src="../assets/images/safeDi.png" />
        </div>
        <div class="safeRight">
          <p>为数据处理系统建立和采用的技术、管理上的安全保护，为的是保护计算机硬件、软件、数据不因偶然和恶意的原因而遭到破坏、更改和泄露。</p>
          <div class="safeList">
            <div class="safeItem">
              <img src="../assets/images/icon_jcss@2x.png" /><span>基础设施安全</span>
            </div>
            <div class="safeItem">
              <img src="../assets/images/icon_ejfw@2x.png" /><span>二级服务安全</span>
            </div>
            <div class="safeItem">
              <img src="../assets/images/icon_sjaq@2x.png" /><span>数据安全</span>
            </div>
            <div class="safeItem">
              <img src="../assets/images/icon_wlaq@2x.png" /><span>网络安全</span>
            </div>
            <div class="safeItem">
              <img src="../assets/images/icon_yyaq@2x.png" /><span>应用安全</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 开放服务 -->
    <div class="service" id="open" ref="open">
      <div style="font-size: 40px;font-family: PingFang SC;color: #FFFFFF;line-height: 36px;text-align: center;"
        @click="demand">
        开放服务
      </div>
      <div class="serWrap">

        <div class="serviceLeft">

          <div class="serBlock" @click="toService">
            <img class="serIcon" src="../assets/images/gyzxfw@2x.png" />
            <span class="serText">工业互联网战略咨询服务</span>
          </div>

          <div class="serBlock" @click="toService">
            <img class="serIcon" src="../assets/images/ryj@2x.png" />
            <span class="serText">智能制造软硬件集成服务</span>
          </div>

          <div class="serBlock" @click="toService">
            <img class="serIcon" src="../assets/images/sx@2x.png" />
            <span class="serText">实训基地及培训服务</span>
          </div>
          <div class="serBlock" @click="toService"> <!--toOpenList-->
            <img class="serIcon" src="../assets/images/api@2x.png" />
            <span class="serText">开放API能力</span>
          </div>

        </div>
        <div class="serviceRight" @click="toService">
          <img class="rImg" src="../assets/images/kffw@2x.png" />
        </div>
        <!-- <div style="display: flex;position: absolute;left: 100px;top: 70px;cursor: pointer;" @click="toService">
          <div style="line-height: 36px;margin-right: 10px;">
            <img src="../assets/images/d@2x.png" style="width: 18px;height: 11px;">
          </div>
          <div style="font-size: 24px;font-family: ZhenyanGB;font-weight: 400;line-height: 36px;color: #FFFFFF;">
            工业互联网战略<br />咨询服务</div>
        </div>
        <div style="display: flex;position: absolute;left: 310px;bottom: 0;cursor: pointer;" @click="toService">
          <div style="line-height: 36px;margin-right: 10px;">
            <img src="../assets/images/d@2x.png" style="width: 18px;height: 11px;">
          </div>
          <div style="font-size: 24px;font-family: ZhenyanGB;font-weight: 400;line-height: 36px;color: #FFFFFF;">
            实训基地及培训<br />服务</div>
        </div>
        <img src="../assets/images/tz@2x.png" style="width: 808px;height: 432px;">
        <div style="display: flex;position: absolute;right: 180px;top: 80px;cursor: pointer;" @click="toService">

          <div style="font-size: 24px;font-family: ZhenyanGB;font-weight: 400;line-height: 36px;color: #FFFFFF;">
            智能制造软硬件<br />集成服务</div>
          <div style="line-height: 36px;margin-left: 10px;">
            <img src="../assets/images/d@2x.png" style="width: 18px;height: 11px;">
          </div>
        </div>
        <div style="display: flex;position: absolute;right: 270px;bottom: -20px;cursor: pointer;" @click="toService">

          <div style="font-size: 24px;font-family: ZhenyanGB;font-weight: 400;line-height: 36px;color: #FFFFFF;">
            开放API能力</div>
          <div style="line-height: 36px;margin-left: 10px;">
            <img src="../assets/images/d@2x.png" style="width: 18px;height: 11px;">
          </div>

        </div> -->
      </div>
    </div>


    <!-- 供应链金融 -->
    <div class="finance" id="finance" ref="finance">
      <div style="font-size: 40px;font-family: PingFang SC;color: #121E30;line-height: 36px;text-align: center;">
        供应链金融
      </div>
      <div style="width: 1373px;margin: 98px auto 0;display: flex;justify-content: space-between;align-items: center;">
        <div style="width: 710px;">
          <div style="display: flex;justify-content: flex-start;">
            <div style="line-height: 36px;margin-right: 20px;">
              <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
            </div>

            <div style="font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #516381;line-height: 36px;">
              基于工业互联网公共服务平台，结合区块链、大数据、云计算等应用，为企业生产数据建立识别标签，形成企业数字资产，并通过与银行信贷系统打通，将企业生产数据转化为数据资产，为优化银行贷后管理和提升企业生产管理提供解决方案，有效解决中小企业融资难、融资成本高等问题，提升中小企业现金流转率，为中小企业做好金融服务。
            </div>
          </div>
          <div style="display: flex;justify-content: flex-start;">
            <div style="line-height: 36px;margin-right: 20px;">
              <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
            </div>
            <div style="font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #516381;line-height: 36px;">
              基于工业互联网平台数据转化为银行授信依据，以标识解析+区块链保障数据真实可信。帮助企业最大限度节省贷款审批时间，大大提升了企业资金周转率，在后疫情时期为企业经营的快速恢复提供保障。</div>
          </div>
        </div>
        <div>
          <img src="../assets/images/jr_sc@2x.png" style="width: 606px;height: 354px;">
        </div>
      </div>
    </div>

    <!-- 能源互联网 -->
    <div class="Internet" id="internet" ref="internet">
      <div style="font-size: 40px;font-family: PingFang SC;color: #121E30;line-height: 36px;text-align: center;">
        法律服务
      </div>
      <div class="lawInfo">
        <div>
          <div class="lawInfo_text">强强联合，合作共赢，一站式为平台赋能</div>
          <div class="lawInfo_bg">
            <div class="law_company">平台与北京华贸硅谷(太原)律师事务所达成深度合作</div>
            <div class="company_introduce"><span class="yuan"></span><span>北京华贸硅谷太原律师事务所是一家专业的律师事务所，为客户提供全面的法律服务。拥有一支高素质的律师团队和先进的管理体系，能够为客户提供优质的法律服务。</span></div>
          </div>
        </div>
        <img src="../assets/images/yt@2x.png" style="width: 678px;height: 378px;">
      </div>
      <!-- <div style="width: 1373px;margin: 98px auto 0;display: flex;justify-content: space-between;align-items: center;">
        <div style="width: 640px;">
          <div style="display: flex;justify-content: flex-start;">
            <div style="line-height: 36px;margin-right: 10px;">
              <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
            </div>

            <div style="font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #fff;line-height: 36px;">
              基于标识解析的能源互联网平台，将分布式能源采集设备，分布式能源存储装置和各类型的电力网络进行标识化，结合先进的电力电子技术，智能化信息管理技术，实现能源双向流动的能源对等交换。

            </div>
          </div>
          <div style="display: flex;justify-content: flex-start;">
            <div style="line-height: 36px;margin-right: 10px;">
              <img src="../assets/images/circular@2x.png" style="width: 10px;height: 10px;">
            </div>
            <div style="font-size: 16px;font-family: PingFang SC;font-weight: 500;color: #fff;line-height: 36px;">
              接入国家工业互联网标识解析体系，通过标识赋码连通各个行业，各个地域，利用大数据、云计算技术实现能源数据全流程追溯，数据关联，信息共享。</div>
          </div>
        </div>
        <div>
          <img src="../assets/images/nyhlw_sc@2x.png" style="width: 605px;height: 427px;">
        </div>
      </div> -->
    </div>
    <!--生态与合作-->
    <div class="ecologyWrap" id="ecology" ref="ecology">
      <div class="wrapTit wrapTit2 pb120">
        生态与合作
      </div>
      <div class="ecoBlock1">
        <div class="ecoBox">
          <div class="ecoTit">
            <countTo :startVal='0' :endVal='ecologyData.enterpriseNum' :duration='2000' ref="count1" separator=""
              :autoplay="false"></countTo>
            +
          </div>
          <div class="ecoSubTit">合作企业</div>
        </div>
        <div class="ecoBox">
          <div class="ecoTit">
            <countTo :startVal='0' :endVal='ecologyData.applicationNum' :duration='2000' ref="count2" separator=""
              :autoplay="false"></countTo>
            +
          </div>
          <div class="ecoSubTit">方案及应用</div>
        </div>
        <div class="ecoBox">
          <div class="ecoTit">
            <countTo :startVal='0' :endVal='ecologyData.customerNum' :duration='2000' ref="count3" separator=""
              :autoplay="false"></countTo>
            +
          </div>
          <div class="ecoSubTit">服务客户</div>
        </div>
      </div>
      <!-- <div class="ecoBlock2">
        <div class="tit">山西省工业互联网协会</div>
        <div class="ecoContent">
          <p>山西省工业互联网协会是由清华大学山西清洁能源研究院牵头，联合清控数联（山西）工业技术有限公司、山西机械化建设集团有限公司、太原清控科创科技园管理有限公司、洪洞县智慧城市建设运营有限公司共同发起。</p>
          <p>
            作为中部六省首个省级工业互联网协会，山西省工业互联网协会以“智联万企、工赋山西”为目标，以工业互联网、大数据等新一代信息技术为依托，智联万企、服务社会，帮助工业制造企业数字化转型发展，推动山西工业化与信息化在更广范围、更深程度、更高水平上实现融合创新。
          <p>
          <p>协会将立足山西，辐射周边，不断深化工业互联网生态体系建设，推动形成网络化、数字化和智能化的发展格局。</p>
        </div>
      </div> -->
    </div>
    <MarketDialog :dialogData='dialogData' @valueData="childrenData"></MarketDialog>
    <PlatformDialog :dialogData='dialogData1' @valueData="childrenData1"></PlatformDialog>
    <!-- <serviceDialog :dialogData='dialogData2' @valueData="childrenData2"></serviceDialog> -->
    <!--页脚-->
    <Footer />

  </div>
</template>
<script>
import {
  getStatus,
  getLogout,
  getJJFAData,
  getArticleData,
  getApplicationData,
  ecology,
  contentByType
} from '@/api/api'
import { serverUrl } from '@/utils/server.js'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import MarketDialog from '@/components/marketDialog.vue'
import PlatformDialog from '@/components/PlatformDialog.vue'
import serviceDialog from '@/components/serviceDialog.vue'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import countTo from "vue-count-to"
import { initUserInfo } from '@/utils/util'
let vm;
export default {
  data() {
    return {
      white: 'white',
      ecologyData: {
        applicationNum: 0,
        customerNum: 0,
        enterpriseNum: 0
      },
      dialogData: false,
      dialogData1: false,
      dialogData2: false,
      timer: null, // countToTimer
      baseURL: serverUrl.baseURL,
      itemList: [],
      scroll: 'home',
      dialogVisible: false,
      itemVal: {},
      dynamicActive: 0,
      dynamicData: [
        // {
        //   time: '10/16',
        //   date: '2022',
        //   data: '2022-10-16 09:42:23',
        //   img:'../assets/images/gyzx01.png',
        //   title: '工业互联网推进新型工业化新突破',
        //   content: '党的二十大报告强调，着力推动高质量发展，建设现代化产业体系，坚持把发展经济的着力点放在实体经济上，促进数字经济和实体经济深度融合。实体经济是一国经济的命脉所在，数字经济是科技革命和产业变革的阵地前沿，中央高度重视数字技术和实体经济深度融合。当前，我国正在从制造大国加快向制造强国迈进，数字技术与制造业的深度融合是实现经济高质量发展的关键路径。'
        // },{
        //   time: '08/09',
        //   date: '2022',
        //   data: '2022-08-09 19:20:54',
        //   img:'../assets/images/gyzx02.png',
        //   title: '人民日报时评：把工业互联网做大做强',
        //   content: '工信部发布数据显示，截至目前，我国工业互联网已应用于45个国民经济大类，产业规模迈过万亿元大关。经过4年多的不懈努力，我国工业互联网从无到有、由大变强，建成网络、平台、安全三大体系，体系化发展位居全球前列。从进企业、入园区到联通更多产业集群，工业互联网在创新发展之路上迈出铿锵步伐，汇聚成产业转型升级的强大势能。'
        // },{
        //   time: '04/22',
        //   date: '2022',
        //   data: '2020-12-31 02:12:50',
        //   img:'../assets/images/gyzx03.png',
        //   title: '工信部明确利用标识解析数据开展运行监测分析和产业链供应链监测',
        //   content: '日前，工业和信息化部发布《工业互联网专项工作组2022年工作计划》（以下简称“《计划》”）。《计划》提出“选取重点区域、重点行业，利用工业互联网标识解析数据探索开展运行监测分析和产业链供应链监测”。'
        // },{
        //   time: '09/09',
        //   date: '2021',
        //   data: '2021-09-09 14:23:52',
        //   img:'../assets/images/gyzx04.png',
        //   title: '重磅：工业互联网标识服务进入牌照时代',
        //   content: '日前，工业和信息化部为中国信息通信研究院工业互联网标识解析国家顶级节点发放首张工业互联网标识服务许可证，这是自《工业互联网标识管理办法》发布以来发放的首张许可证。同时，工联网记者从消息人士处获悉：监管部门将向符合资质的工业互联网标识解析二级节点陆续发放标识服务许可证，这意味着，我国工业互联网标识服务正式进入牌照时代。'
        // }
      ],
      flag: false,
      activeIndex: 1,
      username: '',
      activeSC: 1,
      activeName: '1',
      policyList: [
        // {
        //   title: '山西省人民政府关于深化...',
        //   content: '到2025年，力争培育形成1-2个具有行业竞争力的行业工业互联网平台。推动1000家工业企业依托工业互联网平台实施数字化、网络化改造,形成一批具有示范引领作用的制造业新模式。落户1个公共标...',
        //   time: '2018年8月21日 10:20:30'
        // },
        // {
        //   title: '《山西省工业互联网创新发...',
        //   content: '加快完善工业互联网网络体系建设，促进平台发展，加快提升企业工业互联网意识和能力，新型基础设施进一步完善。初步建成覆盖14大战略性新兴产业集群的工业互联网网络基础设施。',
        //   time: '2021年8月25日 11:05:00'
        // },
        // {
        //   title: '《山西省国民经济和社会发展...',
        //   content: '加快建设工业互联网,构建覆盖全省重点工业区域的工业互联网体系。围绕先进制造升级等领域，推进国家级互联网骨干直联点建设,打造一批国家级、省级工业互联网行业级平台，拓展标识解析应用场景。',
        //   time: '2022年5月2日 09:30:00'
        // }
      ],
      active: 1,
      val: '',
      finalList: [{
        name: '碳效码',
        content: '实现工业企业碳效查询“一码了然”'
      }, {
        name: '唐久码',
        content: '为酒企定制了数字化全链路营销方案及工具'
      }, {
        name: '日化标识码',
        content: '沉淀私域流量、裂变营销获客必备神器'
      }],
      // 解决方案
      jjfaList: [],
      swiperOptions: {
        loop: true,
        speed: 2000,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      // 应用市场
      swiperOption2: {
        // 可见图片张数
        slidesPerView: 3,
        // 默认选中中间一张
        centeredSlides: false,
        centeredSlidesBounds: true,
        // 无限循环
        loop: true,
        // effect: 'coverflow',
        // 小圆点（我此处没使用，列出供参考）
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        coverflow: {
          rotate: 0, // slide做3d旋转时Y轴的旋转角度。默认50。
          stretch: 200, // 每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
          depth: 150, // slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
          // modifier: 1, // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
          slideShadows: false // 开启slide阴影。默认 true。
        },
        // 自动轮播
        autoplay: {
          stopOnLastSlide: true,
          delay: 1000
        },
        // 上下按钮点击轮播效果
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          click: function (e) {
            console.log('---', e.target.id)
            console.log(e)
            let id = e.target.id
            if (id) {
              vm.goYYDetail(id)
            }
          }
        }
      },
      yyData: [

      ],
      runData: [
        {
          'name': '合成生物',
          'prefix': '86.122'
        }, {
          'name': '晋物链',
          'prefix': '86.122'
        }, {
          'name': '布局未来',
          'prefix': '86.122'
        }, {
          'name': '清控数联',
          'prefix': '86.122'
        }, {
          'name': '太原酒厂',
          'prefix': '86.122'
        }, {
          'name': '洪洞智慧',
          'prefix': '86.122'
        }, {
          'name': '洪洞智慧',
          'prefix': '86.122'
        }, {
          'name': '洪洞智慧',
          'prefix': '86.122'
        }, {
          'name': '清控数联',
          'prefix': '86.122'
        }, {
          'name': '太原酒厂',
          'prefix': '86.122'
        }, {
          'name': '洪洞智慧',
          'prefix': '86.122'
        }
      ],
      runPoint: [],
      AnalysisData: null, // 标识解析数据
    }
  },
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide,
    countTo,
    MarketDialog,
    PlatformDialog,
    serviceDialog
  },
  mounted() {

    // 应用市场数据
    this.$nextTick(() => {
      initUserInfo()
      this.getYYData()
    })

  },
  created() {
    vm = this
    var user = JSON.parse(localStorage.getItem('user'))
    if (user && user.username) {
      this.username = user.username
    }
    window.addEventListener('scroll', this.handleScroll1)

    // 获取解决方案数据
    this.getJJFAList()
    // 获取政策支持数据
    this.getpolicyList()
    // 工业资讯
    this.getDynamicData()
    //生态与合作
    this.getEcology()
    // 标识解析
    this.getAnalysis()
    let that = this
    this.timer = setInterval(function () {
      that.startCount()
    }, 3000)
  },
  computed: {
    seamlessScrollOption() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: this.yyData.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 1000, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    // 应用市场处理数字
    getNum(number) {
      if (!number && number != 0) return number;
      var str_num
      if (number >= 1E3 && number < 1E4) {
        str_num = number / 1E3
        return str_num + '千'
      } else if (number >= 1E4 && number < 1E6) {
        str_num = number / 1E4
        return str_num + '万'
      } else if (number >= 1E6 && number < 1E7) {
        str_num = number / 1E6
        return str_num + '百万'
      } else if (number >= 1E7 && number < 1E8) {
        str_num = number / 1E7
        return str_num + '千万'
      } else if (number >= 1E8 && number < 1E10) {
        str_num = number / 1E8
        return str_num + '亿'
      } else if (number >= 1E10 && number < 1E11) {
        str_num = number / 1E10
        return str_num + '百亿'
      } else if (number >= 1E11 && number < 1E12) {
        str_num = number / 1E11
        return str_num + '千亿'
      } else if (number >= 1E12) {
        str_num = number / 1E12
        return str_num + '万亿'
      } else { //一千以下
        return number
      }
    },
    goSecondaryNode() {
      this.$router.push({
        path: "/SecondaryNode"
      })
    },
    goCompanyNode() {
      this.$router.push({
        path: "/CompanyNode"
      })
    },
    goMoreApp() {
      this.$router.push({
        path: "/appList"
      })
    },
    getEcology() {
      ecology().then(res => {
        this.ecologyData = res.data
      })
    },
    getAnalysis() {
      let params = {
        type: 2
      }
      contentByType(params).then(res => {
        this.AnalysisData = res.data
      })
    },
    toService() {
      this.$router.push({
        path: "/ServiceDetails"
      })
    },
    toOpenList() {
      this.$router.push({
        path: "/openList"
      })
    },
    clickProps(id) {
      // let id = e.target.id
      this.goYYDetail(id)
    },
    goYYDetail(id) {
      this.$router.push({
        path: "/marketdetails",
        query: {
          data: id
        },
      })
    },
    goPolDetail(id) {
      this.$router.push({
        path: "/PolicyDetails",
        query: {
          data: id
        },
      })
    },
    goDiscuss() {
      this.$router.push({
        path: "/discuss",
      })
    },
    toSolutionList() {
      this.$router.push({
        path: "/SolutionList"
      })
    },
    formateTime(date, type) {
      if (type === 1) {
        return date.substr(0, 10)
      } else if (type === 2) {
        return date.substr(5, 5).replace('-', '/')
      } else if (type === 3) {
        return date.substr(0, 4)
      } else {
        return date
      }
    },
    demand() {
      this.dialogData2 = true
    },
    childrenData2(val) {
      this.dialogData2 = val
    },
    release() {
      this.dialogData1 = true
    },
    childrenData1(val) {
      this.dialogData1 = false
    },
    childrenData(val) {
      this.dialogData = val
    },
    openDialog() {
      console.log('123')
      this.dialogData = true
    },
    toSecondLevel(name) {
      this.$router.push({
        path: "/" + name,
        query: {
          data: '123'
        },
      })
    },
    startCount() {
      this.$nextTick(() => {
        this.$refs.count1.start()
        this.$refs.count2.start()
        this.$refs.count3.start()
      })

    },
    setScroll(eId) {
      this.scroll = eId
      let dis = document.getElementById(eId).offsetTop
      // let dis = this.$refs[eId].getBoundingClientRect().top
      window.scrollTo({
        top: dis - 115,
        left: 0,
        behavior: "smooth"
      });
    },
    getYYData() {
      let params = {
        page: 0,
        size: 100,
      }
      getApplicationData(params).then(res => {
        let data = res.data.content
        this.yyData = this.handleArr(data)
        console.log('-----yyData', this.yyData)
      })
    },
    handleArr(data) {
      var result = [];
      for (var i = 0, len = data.length; i < len; i += 2) {
        result.push(data.slice(i, i + 2));
      }
      return result
    },
    getJJFAList() {
      let params = {
        indexShow: 1,
        page: 0,
        size: 3,
      }
      getJJFAData(params).then(res => {
        this.jjfaList = res.data.content
      })
    },
    getpolicyList() {
      let params = {
        type: 3,
        page: 0,
        size: 5,
      }
      getArticleData(params).then(res => {
        this.policyList = res.data.content
        console.log('政策数据', this.policyList)
      })
    },
    getDynamicData() {
      let params = {
        type: 2,
        page: 0,
        size: 5,
      }
      getArticleData(params).then(res => {
        this.dynamicData = res.data.content
        this.dynamicActive = 0
        this.itemVal = this.dynamicData[0]
      })
    },
    getDynamic(val) {
      this.dynamicActive = val
      this.itemVal = this.dynamicData[val]
    },
    toDetails(val) {
      this.$router.push({
        path: "/DetailsPage",
        query: {
          data: val
        },
      })
    },
    // 工业资讯详情
    goNewsDetails(id) {
      this.$router.push({
        path: "/IndustryDetails",
        query: {
          data: id
        },
      })
    },
    mouseOver(item) {
      if (item) {
        this.itemList = item
      }
    },
    handleScroll1() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // console.log(scrollTop, '滚动距离')
      if (scrollTop > 0) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    goProvince() {
      this.$router.push({
        path: '/NodePage'
      })
    },
    goGuide() {
      this.$router.push({
        path: '/Guidance'
      })
    },
    toLogin() {
      this.$router.push({
        path: '/platlogin'
      })
    },
    setLogin() {
      getLogout().then(res => {
        localStorage.removeItem('user')
        this.$router.push({
          path: '/platlogin'
        })
      }).catch(err => {
        localStorage.removeItem('user')
        this.$router.push({
          path: '/platlogin'
        })
      })
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    tap(val) {
      this.active = val
    },
    tabNode(val) {
      console.log(val)
      this.activeIndex = val
    },
    handleScroll(id, index) {
      // this.activeIndex = index
      var element = document.getElementById(id);
      this.scroll = element.id
      console.log('==========' + this.scroll)
      element.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
      })

    },
    getCPoint(p) {
      const data = []
      for (let index = 0; index < 360; index = index + p) {
        let x = 100 * Math.cos(Math.PI * 2 * index / 360);
        let y = 200 * Math.sin(Math.PI * 2 * index / 360);
        data.push(...[{ value: [x.toFixed(2), y.toFixed(2)] }])
      }
      return data;
    },
  }
}
</script>
<style scoped>
.titleName {
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 0 10px; */
  cursor: pointer;
  padding: 0 5px;
}

.page {
  width: 100%;
  overflow-x: hidden;
}

/* ::-webkit-scrollbar {
    display: none !important;
  } */

.bs_bj {
  width: 1373px;
  height: 240px;
  background: url('../assets/images/bs_bj@2x.png') top left no-repeat;
  background-size: cover;
  text-align: center;
}

/* /deep/ .el-input__inner {
    width: 1213px;
    height: 64px;
    border: 1px solid #C4CFDE;
    border-radius: 32px;
    text-align: center;
  }

  /deep/ input::-webkit-input-placeholder {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #97A9C7;
  }

  /deep/ input::-moz-placeholder {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #97A9C7;
  }

  /deep/ input:-ms-input-placeholder {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #97A9C7;
  } */

.marketList>div {
  cursor: pointer;
}

.final {
  position: relative;
  width: 100%;
  height: 840px;
  background: url('../assets/images/jjfabg@2x.png') top left no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
}

.platform {
  width: 100%;
  height: 840px;
  box-sizing: border-box;
  /* background: url('../assets/images/gx@2x.png') top center no-repeat; */
  background-size: 100% 1200px;
  background-image: url('../assets/images/gx_bj2@2x.png');
}

.finance {
  width: 100%;
  height: 840px;
  box-sizing: border-box;
  background: linear-gradient(183deg, #F0F6FF, #FFFFFF);
  padding: 88px 0;
}

.policy {
  width: 100%;
  height: 840px;
  box-sizing: border-box;
  background: url('../assets/images/zcbj@2x.png') top left no-repeat;
  background-size: 100% 100%;
  padding: 88px 0;
}

.one {
  width: 919px;
  height: 500px;
  display: flex;
  align-items: center;
  padding: 0 76px;
  /* flex-direction: column; */
}

.one {
  box-sizing: border-box;
  background: url('../assets/images/txm@2x.png') top left no-repeat;
  background-size: cover;
}

.two {
  box-sizing: border-box;
  /* background: url('../assets/images/tjm_bj@2x.png') top left no-repeat; */
  /* background: linear-gradient(183deg, #FFFFFF, #F2F7FF); */
  /* background-size: cover; */
}

.three {
  box-sizing: border-box;
  background: url('../assets/images/rhm_t@2x.png') top left no-repeat;
  background-size: cover;
}

.one .content,
.two .content,
.three .content {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 26px;
  margin: 52px 0 27px;
  width: 765px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}

.line {
  margin: 40px auto 0;
  width: 1214px;
  height: 12px;
  /* background: url('../assets/images/jt@2x.png') top left no-repeat; */
  background-image: linear-gradient(to right, #DFE9FF 5%, #53A6FF 99%, #DFE9FF);
  background-size: cover;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  position: relative;
}

.policy .content {
  text-overflow: -o-ellipsis-lastline;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
}

.policy .item:hover {
  background-color: #fff !important;
}

.policy .item:hover .trangle {
  position: absolute;
  bottom: -10px;
  left: 170px;
  width: 0;
  height: 0;
  border-top: 10px solid #fff !important;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
}

.dynamic {
  width: 100%;
  height: 840px;
  box-sizing: border-box;
  background: url('../assets/images/dtbj@2x.png') top left no-repeat;
  background-size: cover;
  padding: 88px 0;
}

.dynamicLeft {
  width: 475px;
  height: 547px;
  box-sizing: border-box;
  background: url('../assets/images/dt@2x.png') top left no-repeat;
  background-size: cover;
  padding: 30px;
  cursor: pointer;
}

/deep/ .el-tabs__nav-wrap::after {
  background-color: #fff
}

/deep/ .el-tabs__item {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #121E30;
}

/deep/ .el-tabs__active-bar {
  background-color: #0478ED;
}

.dynamicActive1 {
  background: #FFFFFF;
  box-shadow: 6px 6px 16px 0px #EAEDF2;
  border-radius: 10px;
}

.service {
  width: 100%;
  height: 840px;
  box-sizing: border-box;
  background: url('../assets/images/kffw_bj@2x.png') top left no-repeat;
  background-size: cover;
  padding: 88px 0;
}

.Internet {
  width: 100%;
  height: 840px;
  box-sizing: border-box;
  background: url('../assets/images/bj_3@2x.png') top left no-repeat;
  background-size: cover;
  padding: 88px 0;
}

.scOne:hover,
.scTwo:hover,
.scThree:hover,
.scFour:hover,
.scFive:hover,
.scSix:hover,
.scSeven:hover {
  background: #0D65FF !important;
}

.scOne:hover .content,
.scOne:hover .content,
.scTwo:hover .content,
.scThree:hover .content,
.scFour:hover .content,
.scFive:hover .content,
.scSix:hover .content,
.scSeven:hover .content {
  color: #9ABFFF !important;
}

.scOne:hover .left {
  top: 85px !important;
  left: 105px !important;

}

.scOne:hover .right {
  top: 70px;
  left: 140px !important;
}

.scTwo:hover .left,
.scTwo:hover .left,
.scThree:hover .left,
.scFour:hover .left,
.scFive:hover .left,
.scSix:hover .left,
.scSeven:hover .left {
  top: 60px !important;
  left: 105px !important;
}

.scTwo:hover .right,
.scTwo:hover .right,
.scThree:hover .right,
.scFour:hover .right,
.scFive:hover .right,
.scSix:hover .right,
.scSeven:hover .right {
  top: 30px;
  left: 140px !important;
}

.trangle {
  position: absolute;
  bottom: -10px;
  left: 170px;
  width: 0;
  height: 0;
  border-top: 10px solid #ECF2FF;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;

}

.item11,
.item22 {
  width: 240px;
  display: none !important;
}

.item1:hover .item11 {
  display: block !important;
}

.item2:hover .item22 {
  display: block !important;
}

.item3:hover .item33 {
  display: block !important;
}

.item11>div,
.item22>div {
  width: 80px;
}

.item33 {
  width: 480px;
  display: none !important;
}

.item33>div {
  width: 200px;
}

/***轮播图 */
.swiper-container {}

.swiper-slide {
  height: 1080px;
}

.swiper-pagination>>>.swiper-pagination-bullet {
  width: 64px;
  height: 4px;
  background: #0f1c85;
  border-radius: 0;
  opacity: 1;
}

.wrapper>>>.swiper-container-horizontal>.swiper-pagination-bullets {
  bottom: 120px;
  left: 15%;
  width: inherit;
}

.swiper-pagination>>>.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: rgba(15, 77, 255, 1)
}

/** 首页样式 */
.two {
  height: 840px;
  background: linear-gradient(183deg, #F0F6FF, #FFFFFF);
  box-sizing: border-box;
  padding: 88px 0 123px;
}


.jjfaLeftItem {
  width: 359px;
  height: 110px;
  display: flex;
  align-items: center;
  padding-left: 40px;
  position: relative;
  cursor: pointer;
  position: relative;
  margin-bottom: 20px;
}

.jjfaLeftItemTit {
  font-size: 24px;
  font-family: PingFang SC;
  color: #8695AE;
  line-height: 36px;
}

.jjfaLeftItemSubTit {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #8695AE;
  line-height: 26px;
}

.jjfaLeftItem .activeArrow {
  width: 0;
  height: 0;
  border-left: 7px solid #fff;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  display: block;
  position: absolute;
  top: 23px;
  left: 20px;
  display: none;
}

.jjfaLeftItem:hover {
  background: linear-gradient(90deg, #3275F2, rgba(70, 66, 69, 0));
}

.jjfaLeftItem:hover .activeArrow {
  display: block;
}

.jjfaLeftItem:hover .jjfaLeftItemTit {
  color: #fff;
}

.jjfaLeftItem:hover .jjfaLeftItemSubTit {
  color: #fff;
}

.jjfaLeftItem.active {
  background: linear-gradient(90deg, #3275F2, rgba(70, 66, 69, 0));
}

.jjfaLeftItem.active .jjfaLeftItemTit {
  color: #fff;
}

.jjfaLeftItem.active .jjfaLeftItemSubTit {
  color: #fff;
}

.jjfaLeftItem.active .activeArrow {
  display: block;
}

.jjfaRightBlock {
  width: 886px;
  height: 416px;
  border-radius: 20px;
  box-sizing: border-box;
  padding-left: 64px;
  padding-top: 88px;
  padding-right: 64px;
  margin-left: 77px;
}

.jjfaRightBlock .jjfaRightTit {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 50px;
}

.jjfaRightBlock .content {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
}

.moreBtn {
  width: 134px;
  height: 46px;
  border: 1px solid #FFFFFF;
  /* box-shadow: 0px 3px 10px 0px rgba(127,166,214,0.73); */
  border-radius: 23px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 46px;
  cursor: pointer;
  margin-top: 40px;
}

.yyscWrap {
  height: 890px;
  background: linear-gradient(0deg, #ECF4FF, #FFFFFF);
}

.wrapTit {
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #121E30;
  text-align: center;
  padding-top: 88px;
  padding-bottom: 160px;
}

.wrapSubTit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #121E30;
}

.yyscWrapBody {
  width: 1373px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.yyscImg {
  width: 525px;
}

.yyscLeft {
  margin-right: 50px;
}

.yyscLeft .yyscSubTit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #121E30;
}

.yyscLeft .yyscContent {
  padding-top: 47px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #516381;
  line-height: 26px;
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
}

.yyscLeft .cirIcon {
  width: 10px;
  margin-right: 9px;
}

.cirIcon span {
  padding-right: 180px;
}

.yyListWrap {
  width: 790px;
  height: 280px;
  background: linear-gradient(90deg, #D4E5FF, rgba(245, 249, 255, 0.01));
  border-radius: 20px 0px 0px 20px;
  box-sizing: border-box;
  padding: 40px 10px;
  overflow: hidden;
  /* display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap; */
  position: relative;
}

.yyScrollIWraper {
  /* width: 1610px; */
  /* border: 1px solid #f00; */
}

.yyScrollItem {
  float: left;
}

.yyItemBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  width: 230px;
  height: 100px;
  box-sizing: border-box;
  padding-left: 20px;
  /* border: 1px solid #f00; */
}

.yyItemBox .iconImg {
  width: 65px;
  margin-right: 10px;
}

.yyItemBox .itemName {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #353B46;
  line-height: 36px;
}

.yyItemBox .itemCont {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #A3ADC0;
  line-height: 31px;
}

.yyItemBox .itemCont span {
  color: #2178E3;
  font-size: 16px;
  font-weight: bold;
}

.wrapDotImg {
  width: 87px;
  bottom: -30px;
  left: 56px;
  position: absolute;
  /* border: 1px solid #f00; */
}

.wrapTit2 {
  color: #fff;
}

.pb140 {
  padding-bottom: 140px;
}

.platformBody {
  width: 1373px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
}

.platformBody .leftImg {
  width: 530px;
  margin-right: 120px;
}

.platformItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.platformItem .itemCont {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(18, 30, 48, 1);
  line-height: 50px;
}

.btnsBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.blueBtn {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  padding: 8px 30px;
  background: #2B69E7;
  border-radius: 23px;
  border: 1px solid #2B69E7;
  cursor: pointer;
}

.whiteBtn {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(43, 105, 231, 1);
  padding: 8px 30px;
  background: transparent;
  border-radius: 23px;
  border: 1px solid rgba(43, 105, 231, 1);
  cursor: pointer;
}

.platformBody .btnsBox {
  padding-top: 70px;
}

.mr23 {
  margin-right: 23px;
}

.pb107 {
  padding-bottom: 107px;
}

.dataService {
  background: url('../assets/images/dataBg.png') top center no-repeat;
  width: 100%;
  height: 840px;
  background-size: 100% 100%;
}

.dataBody {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: 1373px;
}

.dataImg {
  width: 659px;
  height: 273px;
}

.dataImgWrap {
  width: 659px;
  height: 273px;
  position: relative;
}

.dataImgWrap .mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.dataImgWrap:hover .mask {
  display: none;
}

.dataMsg {
  padding-left: 32px;
  padding-top: 42px;
}

.dataMsg .topTit {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}

.dataMsg .con {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #A3ADC0;
  line-height: 36px;
  width: 630px;
}

.pb120 {
  padding-bottom: 120px;
}

.talentService {
  height: 840px;
  background: linear-gradient(0deg, #E9ECF5, #FFFFFF);
}

.talentBody {
  display: flex;
  justify-content: center;
  align-items: center;
}

.talentCard {
  width: 416px;
  height: 470px;
  background: #FFFFFF;
  box-shadow: 0px 7px 51px 0px #DCE4EC;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.diImg {
  width: 320px;
}

.cardTit {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #121E30;
  line-height: 36px;
  margin: 30px 0 50px;
}

.cardCon {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #516381;
  line-height: 36px;
  text-align: center;
  padding: 0 18px;
}

.aniBox {
  height: 180px;
  width: 200px;
  position: relative;
}

.aniBox .aniImg1 {
  width: 131px;
  height: 132px;
  position: absolute;
  left: 20px;
  top: 30px;
  z-index: 2;
  transition: all 0.5s linear;
}

.aniBox .aniImg2 {
  width: 131px;
  height: 132px;
  position: absolute;
  left: 40px;
  top: 20px;
  z-index: 1;
  transition: all 0.5s linear;
}

.talentCard {
  margin: 0 22px;
}

.talentCard:hover .aniImg1 {
  left: 0;
  top: 40px
}

.talentCard:hover .aniImg2 {
  left: 60px;
  top: 10px;
}

.ecologyWrap {
  height: 440px;
  background: url('../assets/images/st@2x.png') top center no-repeat;
}

.ecoBlock1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1000px;
  margin: 0 auto;

}

.ecoBox {
  text-align: center;
}

.ecoTit {
  font-size: 54px;
  font-family: DIN;
  font-weight: 500;
  color: #FFFFFF;
  width: 300px;
  text-align: center;
}

.ecoSubTit {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #78A2FF;
  line-height: 30px;
}

.ecoBlock2 {
  width: 1340px;
  height: 335px;
  background: rgba(255, 255, 255, 0.3);
  margin: 65px auto 0;
  border-radius: 20px;
}

.ecoBlock2 .tit {
  font-size: 30px;
  font-family: PingFang SC;
  color: #FFFFFF;
  text-align: center;
  padding: 50px 0 40px;
}

.ecoContent {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 33px;
}

.ecoContent p {
  text-indent: 2rem;
  margin: 0;
  padding: 0 75px;
}

.bannerWrap {
  width: 100%;
  height: 1080px;
  position: relative;
  /* background: #f00; */
}

.bannerWrap1 {
  background: url('../assets/images/banner1.jpg') top center no-repeat;
  background-size: cover;
}

.bannerWrap2 {
  background: url('../assets/images/banner2.jpg') top center no-repeat;
  background-size: cover;
}

.bannerWrap3 {
  background: url('../assets/images/banner3.jpg') top center no-repeat;
  background-size: cover;
}

.bannerWrap4 {
  background: url('../assets/images/banner4.jpg') top center no-repeat;
  background-size: cover;
}

.bannerWrap5 {
  background: url('../assets/images/banner5.jpg') top center no-repeat;
  background-size: cover;
}

.bannerWrap .leftContnet {
  width: 45%;
  padding-top: 380px;
  padding-left: 45px;
}

.bannerWrap .leftContnet .bigTit {
  font-size: 70px;
  font-family: PingFang SC;
  color: #fff;
}

.bannerWrap .leftContnet .subTit {
  font-size: 50px;
  font-family: PingFang SC;
  color: #fff;
  padding-top: 10px;
}

.info {
  font-family: PingFang SC;
  color: #fff;
  font-size: 20px;
  padding-top: 58px;
  line-height: 30px;
}

.bannerBtn {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  padding: 10px 30px;
  border: 1px solid #FFFFFF;
  border-radius: 28px;
  position: absolute;
  bottom: 260px;
  left: 15%;
}

.gyzxImgBox {
  width: 400px;
  height: 204px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
}

.gyzxImgBox img {
  width: 100%;
  height: 100%;
}

.nodeTit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #7A89A2;
}

.nodeTit.active {
  color: #0C67D8;
  position: relative;
}

.nodeTit.active::after {
  display: block;
  content: "";
  width: 215px;
  height: 2px;
  background: #0C67D8;
  position: absolute;
  bottom: -31px;
  left: 50%;
  transform: translateX(-50%);
}

.jjfaMoreBtn {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: left;
  padding-left: 40px;
  cursor: pointer;
}

.pb80 {
  padding-bottom: 80px;
}

.line3 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #516381;
  line-height: 27px;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
}

.dynamicItem:hover {
  background: #fff;
  box-shadow: 6px 6px 16px 0px #EAEDF2;
  border-radius: 10px;
}

.datasWrap {
  background: #0C1728;
  box-shadow: 0px 7px 27px 0px #16171A;
  border-radius: 20px;
  width: 659px;
  overflow: hidden;
  padding-bottom: 38px;
}

.policy .zcBox {
  position: relative;
}

.policy .zcBox:hover::after {
  border-top: 10px solid #fff;
}

.policy .zcBox::after {
  display: block;
  content: "";
  width: 0;
  height: 0;
  border-top: 10px solid rgb(236, 242, 255);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  display: block;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}

/* .policy .content
    display: block;
    content: "";
    width: 0;
    height: 0;
    border-left: 7px solid #f00;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    display: block;
    position: absolute;
    top: 23px;
    left: 20px;
    display: none;
  } */
.flagWrap {
  /* border: 1px solid #f00; */
  position: absolute;
  width: 800px;
  height: 610px;
  bottom: 150px;
  right: 10px;
}

.flagBox {
  position: absolute;
  /* border: 1px solid #f00; */
  width: 20px;
  height: 20px;
  color: #fff;
}

.flagBotBox1 {
  top: 385px;
  left: 0;
  transform: scale(1, 1);
  animation: doBotMove1 5s infinite linear;
}

.flagBotBox2 {
  top: 470px;
  left: 200px;
  transform: scale(1.2, 1.2);
  animation: doBotMove2 5s infinite linear;
}

.flagBotBox3 {
  top: 470px;
  left: 400px;
  transform: scale(1.2, 1.2);
  animation: doBotMove3 5s infinite linear;
}

.flagBotBox4 {
  top: 368px;
  left: 639px;
  transform: scale(1, 1);
  animation: doBotMove4 5s infinite linear;
}

.flagBotBox5 {
  top: 300px;
  left: 200px;
  transform: scale(0.8, 0.8);
}

.flagBotBox6 {
  top: 300px;
  left: 450px;
  transform: scale(0.8, 0.8);
}

@keyframes doBotMove1 {
  15% {
    top: 300px;
    left: 200px;
    transform: scale(0.8, 0.8);
  }

  30% {
    top: 300px;
    left: 450px;
    transform: scale(0.8, 0.8);
  }

  45% {
    top: 368px;
    left: 639px;
    transform: scale(1, 1);
  }

  60% {
    top: 470px;
    left: 400px;
    transform: scale(1.2, 1.2);
  }

  75% {
    top: 470px;
    left: 200px;
    transform: scale(1.2, 1.2);
  }

  100% {
    top: 385px;
    left: 0;
    transform: scale(1, 1);
  }
}

@keyframes doBotMove2 {
  15% {
    top: 385px;
    left: 0;
    transform: scale(1, 1);
  }

  30% {
    top: 300px;
    left: 200px;
    transform: scale(0.8, 0.8);
  }

  45% {
    top: 300px;
    left: 450px;
    transform: scale(0.8, 0.8);
  }

  60% {
    top: 368px;
    left: 639px;
    transform: scale(1, 1);
  }

  75% {
    top: 470px;
    left: 400px;
    transform: scale(1.2, 1.2);
  }

  100% {
    top: 470px;
    left: 200px;
    transform: scale(1.2, 1.2);
  }
}

@keyframes doBotMove3 {
  15% {
    top: 470px;
    left: 200px;
    transform: scale(1.2, 1.2);
  }

  30% {
    top: 385px;
    left: 0;
    transform: scale(1, 1);
  }

  45% {
    top: 300px;
    left: 200px;
    transform: scale(0.8, 0.8);
  }

  60% {
    top: 300px;
    left: 450px;
    transform: scale(0.8, 0.8);
  }

  75% {
    top: 368px;
    left: 639px;
    transform: scale(1, 1);
  }

  100% {
    top: 470px;
    left: 400px;
    transform: scale(1.2, 1.2);
  }
}

@keyframes doBotMove4 {
  15% {
    top: 470px;
    left: 400px;
    transform: scale(1.2, 1.2);
  }

  30% {
    top: 470px;
    left: 200px;
    transform: scale(1.2, 1.2);
  }

  45% {
    top: 385px;
    left: 0;
    transform: scale(1, 1);
  }

  60% {
    top: 300px;
    left: 200px;
    transform: scale(0.8, 0.8);
  }

  75% {
    top: 300px;
    left: 450px;
    transform: scale(0.8, 0.8);
  }

  100% {
    top: 368px;
    left: 639px;
    transform: scale(1, 1);
  }
}

.moreTipBtn {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #516381;
  cursor: pointer;
  position: absolute;
  right: -80px;
}

.newsInfo {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #516381;
  line-height: 23px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.polTime {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #516381;
  line-height: 26px;
  margin-top: 33px;
}

.polInfo {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #516381;
  line-height: 27px;
  margin-top: 10px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;

}

.polBlockTit {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #121E30;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.yyOutWrap {
  /* border: 1px solid #f00; */
  height: 300px;
  position: relative;
  width: 787px;
  overflow: hidden;
}

/**/
.mySlide {
  width: 260px;
  height: 300px;
  /* border: 1px solid #000; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0;
}


.serWrap {
  position: relative;
  width: 1373px;
  margin: 124px auto 0;
  display: flex;
  justify-content: space-around;
}

.serviceLeft {
  /* border: 1px solid #f00; */
  width: 550px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.serBlock {
  display: inline-block;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 160px;
  margin: 50px;
  cursor: pointer;
}

.serBlock:hover {
  /* transform: scale(1.2,1.2); */
}

.serIcon {
  height: 73px;
  margin-bottom: 20px;
}

.serText {
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  text-align: center;
}

.serviceRight .rImg {
  width: 808px;
}

.safe {
  width: 100%;
  height: 840px;
  background: #0641c1 url('../assets/images/safeBg.png') top center no-repeat;
  background-size: cover;
}

.safeTit {
  font-size: 40px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  text-align: center;
  padding-top: 102px;
  margin-bottom: 103px;
}

.safeLeft {
  width: 436px;
  height: 500px;
  /* border: 1px solid #f00; */
  position: relative;
}

.safeDun {
  width: 280px;
  margin-left: 78px;
  position: relative;
  z-index: 2;
}

.safeYing {
  width: 200px;
  /* border: 1px solid #f00; */
  position: absolute;
  top: 300px;
  left: 50%;
  margin-left: -100px;
}

.dunAni {
  animation: dunAnimation 2s linear infinite;
}

.yingAni {
  animation: yingAnimation 2s linear infinite;
}

.safeDi {
  width: 436px;
  height: 217px;
  position: absolute;
  top: 250px;
  left: 0;
  z-index: 1;
}

.safeWrap {
  width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@keyframes dunAnimation {
  0% {
    margin-top: 0;
  }

  50% {
    margin-top: -30px;
  }

  100% {
    margin-top: 0;
  }
}

@keyframes yingAnimation {
  0% {
    transform: scale(1, 1)
  }

  50% {
    transform: scale(0.6, 0.6)
  }

  100% {
    transform: scale(1, 1)
  }
}

.safeRight {
  width: 695px;
  /* border: 1px solid #f00; */
}

.safeRight p {
  margin: 59px 0 104px;
  padding: 0;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
}

.safeItem {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #F0F5FF;
  display: inline-block;
  padding: 10px 23px;
  margin-right: 20px;
  margin-bottom: 40px;
}

.safeItem img {
  width: 26px;
  margin-right: 18px;
  vertical-align: middle
}

.safeItem span {
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  vertical-align: middle;
}

.zcInformation {
  width: 100%;
  height: 840px;
  box-sizing: border-box;
  background: url('../assets/images/dtbj@2x.png') top left no-repeat;
  background-size: 100% 100%;
}

.zcInner {
  width: 1300px;
  margin: 0 auto;
  /* border: 1px solid #f00; */
}

.zcTit {
  font-size: 40px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #121E30;
  padding: 88px 0 70px;
  text-align: center;
}

.zcWrap {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
}

.zcInfoBox {
  width: 45%;
  /* border: 1px solid #f00; */
}

.zcWrap .zcInfoBox:nth-child(1) {
  margin-right: 68px;
}

.zcInfoBox .topInfo {
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #121E30;
  position: relative;
  vertical-align: middle;
  margin-bottom: 20px;
  padding-left: 15px;
}

.zcInfoBox .topInfo1::after {
  content: "";
  display: block;
  width: 4px;
  height: 24px;
  background: #0F5EFF;
  border-radius: 1px;
  position: absolute;
  left: 0;
  top: 6px;
}

.zcInfoBox .topInfo2::after {
  content: "";
  display: block;
  width: 4px;
  height: 24px;
  background: #0FBEFF;
  border-radius: 1px;
  position: absolute;
  left: 0;
  top: 6px;
}

.zcInfoBox .topInfo span {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #516381;
  float: right;
  vertical-align: middle;
  line-height: 50px;
  cursor: pointer;
}

.zcInfoBox .topInfo span img {
  vertical-align: middle;
  width: 12px;
  height: 12px;
  margin-left: 5px;
}

.zcInfoBox .topImgBox {
  width: 100%;
  height: 222px;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 10px;
  overflow: hidden;
  cursor: pointer;
}

.topImgBar {
  height: 42px;
  background: rgba(0, 0, 0, 0.4);
  line-height: 42px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  box-sizing: border-box;
  padding: 0 18px 0 25px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}

.topImgBar .time {
  float: right;
  color: #CCD3DF;
}

.zcInfoList .infoItem {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
  border-bottom: 1px solid #CBD3E9;
  position: relative;
  margin-left: 20px;
  padding-right: 15px;
  padding-bottom: 10px;
  padding-top: 10px;
  cursor: pointer;
}

.zcInfoBox .lineText {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  /* border: 1px solid #f00; */
  width: 70%;
  display: inline-block;
}

.zcInfoList .infoItem::after {
  content: "";
  display: block;
  width: 4px;
  height: 11px;
  background: #CBD3E9;
  border-radius: 1px;
  position: absolute;
  left: -20px;
  top: 20px;
}

.zcInfoList .infoItem .time {
  float: right;
}

.moreApp {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #0F5EFF;
  text-align: left;
  padding: 20px 0 20px 20px;
  cursor: pointer;
}

.iotWrap {
  width: 100%;
  height: 840px;
  background: url('../assets/images/iot_bj@2x.png') top center no-repeat;
}

.iotInnerWrap {
  width: 1300px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.iotTit {
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  padding-top: 108px;
  padding-bottom: 96px;
}

.iotLeft {
  flex: 1;
  padding-right: 100px;
  box-sizing: border-box;
}

.iotLeft>div {
  margin-bottom: 25px;
}

.iotLeft .cirIcon {
  width: 10px;
  height: 10px;
  margin-right: 18px;
  vertical-align: middle;
}

.iotLeft span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 36px;
  vertical-align: middle;
}

.iotLeft em {
  font-style: normal;
  display: block;
  padding-left: 30px;
  font-size: 16px;
}

.iotLeft em b {
  font-weight: normal;
  color: #0c67d8;
  margin-right: 10px;
  font-size: 14px;
}

.iotRight {
  width: 650px;
  height: 515px;
  background: url('../assets/images/iot_right@2x.png') top center no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.iotRight .name {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #66F4FF;
  position: absolute;
}

.iotRight .line {
  display: block;
  height: 46px;
  width: 1px;
  border-left: 1px dashed rgba(102, 244, 255, 1);
  position: absolute;
  animation: upAnimate 3s infinite linear;
}

.iotRight .name.active {
  animation: showName 1s infinite 1
}

.iotRight .line.active {
  animation: upAnimate 3s infinite 1
}

@keyframes showName {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes upAnimate {
  0% {
    height: 0;
  }

  30% {
    height: 0;
  }

  100% {
    height: 46px;
  }
}

.iotRight .name0 {
  top: 200px;
  left: 48px;
}

.iotRight .line0 {
  left: 72px;
  bottom: 263px;
}

.iotRight .name1 {
  top: 76px;
  right: 68px;
}

.iotRight .line1 {
  right: 99px;
  bottom: 363px;
}

.iotRight .name2 {
  top: 352px;
  left: 24px;
}

.iotRight .line2 {
  bottom: 96px;
  left: 40px;
}

.iotRight .name3 {
  top: 369px;
  left: 216px;
}

.iotRight .line3 {
  left: 236px;
  bottom: 79px
}

.iotRight .name4 {
  left: 367px;
  top: 415px;
}

.iotRight .line4 {
  left: 407px;
  bottom: 34px;
}

.iotRight .name5 {
  top: 308px;
  left: 524px;
}

.iotRight .line5 {
  left: 553px;
  bottom: 140px;
}

.handleWrap {
  background: linear-gradient(183deg, #FFFFFF, #F2F7FF);
}

.platTit {
  color: rgba(18, 30, 48, 1);
}

.lawInfo {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 80px 200px 0;
}

.lawInfo_text {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #121E30;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lawInfo_bg {
  width: 865px;
  height: 249px;
  background: url('../assets/images/ys@2x.png') top left no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 30px 75px 0 160px;
  margin-right: 20px;
}

.law_company {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0C67D8;
}

.company_introduce {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #121E30;
  line-height: 30px;
  margin-top: 35px;
  display: flex;
  justify-content: flex-start;
  /* flex-wrap: wrap; */
}

.yuan {
  display: inline-block;
  max-width: 10px;
  max-height: 10px;
  min-width: 10px;
  min-height: 10px;
  border-radius: 50%;
  border: 3px solid #0C67D8;
  box-sizing: border-box;
  margin-top: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue